<form class="pay-invoice-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INCORRECT_PAYMENT.PAY_INVOICE' | translate }}</h4>
  <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
    <app-money-box [control]="form.controls['amount']"></app-money-box>
    <div class="astral-layout-item">
      <app-autocomplete-remote
        [control]="form.controls['invoice']"
        [service]="filterService"
        [defaultSearch]="defaultFilter"
        (itemSelected)="invoiceSelected($event)"
      ></app-autocomplete-remote>
    </div>
    @if (differentCompany) {
      <app-information-block [text]="'INCORRECT_PAYMENT.WARN_DIFFERENT_COMPANY' | translate"></app-information-block>
    }
    <astral-date-picker
      [control]="form.controls['businessTransactionDate']"
      [label]="'PAYMENT.DATE'"
      [model]="dataContext.businessTransactionDate"
      [isRequired]="true"
    ></astral-date-picker>
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
